export default {
  "APP_COMMERCE_VIEW": "COMMERCEUSER_VIEW",
  "APP_PRODUCT_IDENTIFIER_UPDATE":"COMMON_ADMIN",
  "STOCK_MOVE_APP_VIEW": "STOCK_MOVE_APP_VIEW"
} as any